import { axiosInstance } from '@/api/main/instance'
import { ApiError, ApiResponse, QueryParams } from '@/api/types'
import { AxiosRequestConfig } from 'axios'

// Error handling function
export function handleApiResponse<T>(response: ApiResponse<T>): T {
  if (response.isFailure) {
    const formattedMessage =
      response.failures?.map((f) => `[${f.id}] ${f.description}`).join(', ') || 'Unknown API error'

    const error: ApiError = {
      message: formattedMessage,
      failures: response.failures,
    }

    throw error
  }

  if (!response.isSuccess || response.value === undefined) {
    throw {
      message: 'Некорректный ответ от сервера',
    } satisfies ApiError
  }

  return response.value
}

// GET request
export async function apiGet<T>(
  endpoint: string,
  params?: QueryParams,
  config?: Omit<AxiosRequestConfig, 'params'>
): Promise<T> {
  const response = await axiosInstance.get<ApiResponse<T>>(endpoint, {
    params,
    ...config,
  })
  return handleApiResponse(response.data)
}

// POST request
export async function apiPost<T>(
  endpoint: string,
  data: unknown,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await axiosInstance.post<ApiResponse<T>>(endpoint, data, config)
  return handleApiResponse(response.data)
}

// PUT request
export async function apiPut<T>(
  endpoint: string,
  data: unknown,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await axiosInstance.put<ApiResponse<T>>(endpoint, data, config)
  return handleApiResponse(response.data)
}

// PATCH request
export async function apiPatch<T>(
  endpoint: string,
  data: unknown,
  config?: AxiosRequestConfig
): Promise<T> {
  const response = await axiosInstance.patch<ApiResponse<T>>(endpoint, data, config)
  return handleApiResponse(response.data)
}

// DELETE request
export async function apiDelete<T>(endpoint: string, config?: AxiosRequestConfig): Promise<T> {
  const response = await axiosInstance.delete<ApiResponse<T>>(endpoint, config)
  return handleApiResponse(response.data)
}
